export default __webpack_public_path__ + "media/music/8d4d939806449f1a36e317be8594794c.mp3";